import React from "react";

import { toHumanDuration } from "../../utils";
import { formatDateMonthTimeShort } from "~/src/utils/formatting";

interface AlarmProps {
  value: number | null;
  warn: number;
  alarm: number;
}

const Alarm: React.FC<AlarmProps> = ({ value, warn, alarm }) => {
  let emoji = "";
  let title = "";

  if (value === null) {
    emoji = "";
    title = "";
  } else if (value >= alarm) {
    emoji = "🚨";
    title = `Last recorded event was at ${formatDateMonthTimeShort(value)}, more than ${toHumanDuration(alarm)} ago`;
  } else if (value >= warn) {
    emoji = "⚠️";
    title = `Last recorded event was at ${formatDateMonthTimeShort(value)}, more than ${toHumanDuration(warn)} ago`;
  }

  return (
    <span title={title} style={{ whiteSpace: "nowrap", cursor: "default" }}>
      {toHumanDuration(value)} {emoji}
    </span>
  );
};

export default Alarm;
